<template>
  <div class="row h-100 w-100">
    <div class="col-12 my-auto text-center">
      <span class="percent">
        {{total2021}}</span><br />
      fournisseurs en 2020-2021
    </div>
    <div class="col-12 my-auto text-center">
      <span class="percent">
        {{soumis2021}} %</span><br />
      soumis en 2020-2021
    </div>
    <div class="col-12 my-auto text-center">
      <span class="percent">
        {{soumis1920}} %</span><br />
      soumis en 2019-2020
    </div>
    <div class="col-12 my-auto text-center">
      <span class="percent">
        {{soumis1819}} %</span><br />
      soumis en 2018-2019
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],

  computed: {
    total2021() {
      return this.data.total_2021;
    },
    soumis1819() {
      return (100*this.data.soumis_1819/this.data.total_1819).toFixed(1);
    },
    soumis1920() {
      return (100*this.data.soumis_1920/this.data.total_1920).toFixed(1);
    },
    soumis2021() {
      return (100*this.data.soumis_2021/this.data.total_2021).toFixed(1);
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Righteous&display=swap');
span.percent {
  font-size: 40px;
  font-family: 'Righteous', cursive;
}
</style>
